import React from "react";
import { IIcon } from "./Icon.types";

const PauseIcon: React.FC<IIcon> = ({
  width= "32",
  height= "32",
  fill= "#FFFFFF",
  viewBox= "0 0 32 32",
  onClick,
  className,
}: IIcon): React.JSX.Element => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      stroke={fill}
      viewBox={viewBox}
      onClick={onClick}
      className={className}
      data-testid="pauseIcon"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 6C8.44772 6 8 6.44772 8 7V25C8 25.5523 8.44772 26 9 26H13C13.5523 26 14 25.5523 14 25V7C14 6.44772 13.5523 6 13 6H9ZM19 6C18.4477 6 18 6.44772 18 7V25C18 25.5523 18.4477 26 19 26H23C23.5523 26 24 25.5523 24 25V7C24 6.44772 23.5523 6 23 6H19Z"
        fill="white"
      />
    </svg>
  );
};

export default PauseIcon;
